// extracted by mini-css-extract-plugin
module.exports = {"copyright":"Copyright_copyright__3Z3YL"};